import { KeyedObject } from 'bernie-core/dist/source';
import * as React from 'react';
import { UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkMarkSize } from 'uitk-react-mark';
import { ActivityDestinationViewSearch } from '../../../../../../common/__generated__/api';
import { IconMark } from '../../../../../common/icon-mark';

type Icon = ActivityDestinationViewSearch.Icon | ActivityDestinationViewSearch.______Icon | null;
type Mark = ActivityDestinationViewSearch.Mark | ActivityDestinationViewSearch._____Mark | null;

export interface ActivityFeatureProps extends KeyedObject {
  label: string;
  a11yLabel?: string;
  icon?: Icon;
  mark?: Mark;
}

export const ActivityFeature = ({ label, a11yLabel, icon, mark, ...extraProps }: ActivityFeatureProps): JSX.Element => (
  <UitkLayoutFlex alignItems="center" {...extraProps}>
    {(icon || mark) && (
      <IconMark
        icon={icon}
        mark={mark}
        defaultIconSize={UitkIconSize.EXTRA_SMALL}
        markSize={UitkMarkSize.EXTRA_SMALL}
        className="all-r-margin-one"
      />
    )}
    <span>
      {a11yLabel && <span className="is-visually-hidden">{a11yLabel}</span>}
      <span aria-hidden={Boolean(a11yLabel)}>{label}</span>
    </span>
  </UitkLayoutFlex>
);
